import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import type { DynamicListTemplate } from '@/interfaces/api/general/dynamicListTemplate';
import { buildTagItems, COLORS } from './templateUtils';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';

interface TemplateLabel {
  id: number;
  name: string;
  type: string;
  description?: string;
  display_order?: number;
}

interface TemplateLaw {
  id: number;
  name: string;
}

interface TemplateCardProps {
  template: DynamicListTemplate & {
    badges?: string[];
    labels?: TemplateLabel[];
    laws?: TemplateLaw[];
    is_applied?: boolean;
    has_access?: boolean;
    template_type?: 'free_default' | 'free' | 'paid';
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateCard',
  props: {
    template: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  template: DynamicListTemplate & {
    badges?: string[];
    labels?: TemplateLabel[];
    laws?: TemplateLaw[];
    is_applied?: boolean;
    has_access?: boolean;
    template_type?: 'free_default' | 'free' | 'paid';
  };
};

const $t = i18n.tc.bind(i18n);

// Types



const hover = ref(false);

const isPaidTemplate = computed(() => {
  return props.template.template_type === 'paid';
});

const handleClick = () => {
  emit('click');
};

const allTags = computed(() => buildTagItems(props.template));

return { __sfc: true,$t, props, emit, hover, isPaidTemplate, handleClick, allTags, COLORS, sharedMessages }
}

})